import React from 'react'
import './ContactCard.css'

function ContactCard(props) {
  let data = props.props
  return (
    <a href={data.href} className='contact-card my-2'>
      <div
        className='card bg-light'
        style={{ maxWidth: '30rem', margin: '0 auto' }}>
        <div className='card-body d-flex justify-content-between'>
          <i className={data.icon}></i>
          <span>{data.text}</span>
        </div>
      </div>
    </a>
  )
}

export default ContactCard
